import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { extDBAssetEntriesManager, type IExtDBAssetEntry } from '@inpart-io/padme-iap';

import { store } from '@/store';

import { getSearchModule } from '../base/search/module';
import { actions } from './actions';

const EXT_DB_ASSET_ENTRY_MODULE = 'extDBAssetEntry';

const dataObjectModule = getDataObjectsModule<IExtDBAssetEntry>(extDBAssetEntriesManager, 3);
const searchModule = getSearchModule<IExtDBAssetEntry>(extDBAssetEntriesManager);

const extDBAssetEntryModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(EXT_DB_ASSET_ENTRY_MODULE, extDBAssetEntryModuleInstance);

export { EXT_DB_ASSET_ENTRY_MODULE };
